export default {
    PremiumDashSecurityManage: {
        datapoint: {
            name: 'PremiumDashSecurityManageClicked',
        },
    },
    PremiumDashViewRecentActivity: {
        datapoint: {
            name: 'PremiumDashViewRecentActivityClicked',
        },
    },
};
//# sourceMappingURL=datapoints.js.map